<template>
    <div class="social-links-block">
        <ul class="links" v-if="getOptions.share_module">
            <li v-for="(link, k) in getOptions.share_module" :key="k" :class="k">
                <a rel="noopener" :aria-label="getText(k)" :href="link" :title="getText(k)" target="_blank" v-html="getIcon(k)"></a>
                <span v-if="caption">{{getText(k)}}</span>
            </li>
        </ul>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import icons from '@/components/../icons';

export default {
    name: 'page-logo',
    props: {
        // in PX
        light: {
            type: Boolean,
            default: false,
        },
        caption: {
            type: Boolean,
            default: false,
        },
    },
    data(){
        return{
            wpvue : window.WPVUE,
        }
    },
    methods:{
        getIcon(iconName){
            const fn = icons[iconName];
            if(typeof icons[iconName] === 'function'){
               return fn('#fff')
            }
        },
        getText(iconName){
            let text = iconName
            if(text === 'youtube') text = 'YouTube'

            return text;
        }
    },
    computed:{
        ...mapGetters([
            'getOptions',
        ])
    },
    
};
</script>


<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
.social-links-block{
    margin-left: -12.5px;
    margin-right: -12.5px;
    @include mquery($tablet){
        margin-left: -8px;
        margin-right: -8px;
    }
    a{
        display: block;
        cursor: pointer;
    }
    li{
        margin-left: 12.5px;
        margin-right: 12.5px;
        display: inline-block;
        @include mquery($tablet){
            margin-left: 8px;
            margin-right: 8px;
        }
    }
    svg{
        width: 50px;
        height: 50px;
        @include mquery($tablet){
            width: 30px;
            height: 30px;
        }
    }
    .links{
		padding: 0;
		margin: 0;
		list-style: none;
		li{
			list-style: none;
        } 
    }
}
</style>